// src/data/partners.js

export const PARTNER_TYPES = [
    {
        id: 'traditional',
        label: 'Traditional Financial Institutions',
        description: 'Commercial & Retail Banks, Credit Unions, Trust Companies.',
        fit: 'Best for established businesses with stable cash flow requiring term loans or lines of credit.'
    },
    {
        id: 'government',
        label: 'Government-Backed & Specialized',
        description: 'BDC, EDC, CSBFP.',
        fit: 'Best for SMEs, exporters, and modernization projects. often lower cost but slower speed.'
    },
    {
        id: 'private',
        label: 'Private & Alternative Capital',
        description: 'Private Credit, Venture Capital (VC), Private Equity (PE).',
        fit: 'High-growth startups (AI, BioTech) needing flexible, bespoke capital or equity partnerships.'
    },
    {
        id: 'fintech',
        label: 'Emerging Fintech & Specialized',
        description: 'Asset-Backed Finance (ABF), Merchant Cash Advance (MCA), Crowdfunding.',
        fit: 'Projects needing speed (underwriting via data) or tied to specific assets/invoices.'
    }
];

export const QUALIFICATION_CRITERIA = {
    identity: [
        { id: 'reg_status', label: 'Regulatory Status', type: 'text', placeholder: 'e.g., Chartered Bank, Exempt Market Dealer' },
        { id: 'check_size', label: 'Check Size Capacity (Min/Max)', type: 'text', placeholder: 'e.g., $500k - $10M' },
        { id: 'speed', label: 'Speed to Close (Days)', type: 'number', placeholder: 'e.g., 45' }
    ],
    economics: [
        { id: 'base_rate', label: 'Base Interest Rate / APR', type: 'text', placeholder: 'e.g., Prime + 2%' },
        { id: 'fees', label: 'Origination/Facility Fees (%)', type: 'number', placeholder: 'e.g., 1.5' },
        { id: 'equity', label: 'Equity/Warrant Requirement', type: 'select', options: ['None', 'Negotiable', 'Required (<5%)', 'Required (>5%)'] },
        { id: 'covenants', label: 'Covenant Heaviness', type: 'select', options: ['Light (Financial only)', 'Moderate', 'Strict'] },
        { id: 'guarantees', label: 'Personal Guarantees', type: 'select', options: ['Required', 'Not Required', 'Partial'] }
    ]
};

// Placeholder for future approved partners
export const APPROVED_PARTNERS = [];